import CardTable from 'components/CardTable/CardTable'
import { useOpenComponent } from 'hooks/useOpenComponent'
import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import AddIcon from "@mui/icons-material/Add";
import { columns } from './columns'
import Snackbars from "components/Snackbar/Snackbar.js";
import { resetProductSelected, addProductMode, getProductsCatalog } from 'redux/actions/productsCatalog/productsCatalogActions'
import RegularButton from 'components/CustomButtons/Button'
import { Category } from '@mui/icons-material'
import { useSearch } from 'hooks/useSearch'
import { FormProductEdit } from './FormProductEdit'
import { ModalV2 } from 'components/Modal/ModalV2'

export const Products = () => {
  // custom hook
  const { clearSnackbar, clearSearch } = useSearch();
  const { token } = useSelector(state => state.login)
  const { products, addProduct, addMode } = useSelector(state => state.productsCatalog)
  const { color, message, isOpen: isOpenSnack, isLoading } = useSelector((state) => state.search);
  const { isOpen, handleIsOpen } = useOpenComponent()
  const formRef = useRef(null)
  const dispatch = useDispatch()

  const handleClose = () => {
    dispatch(resetProductSelected())
    handleIsOpen()
  }
  
  const handleOpenAdd = () => {
    dispatch(addProductMode())
    handleIsOpen()
  }

  const handleFormSubmit = () => {
    formRef.current?.submit()
  }

  useEffect(() => {
    dispatch(getProductsCatalog(token))
    clearSearch()
  }, [token])

  const mapData = Object.values(products).map(product => ({
    ...product,
    modal: handleIsOpen,
  }))

  const modalTitle = addMode ? 'Agregar nuevo producto' : 'Modificar producto'
  const submitBtnText = addMode ? 'Agregar' : 'Guardar'
  
  return (
    <React.Fragment>
      <CardTable
        data={mapData}
        columns={columns}
        loading={isLoading}
        hasHeader
        title={"Catalogo de Productos"}
        icon={<Category />}
        blockBtn
        hasControl
        controls={
          addProduct && (
            <RegularButton round justIcon color="info" style={{ margin: 10 }} onClick={handleOpenAdd}>
              <AddIcon style={{ margin: 0 }}/>
            </RegularButton>
          )
        }
      />
      <ModalV2
        open={isOpen}
        onClose={handleClose}
        toRight
        title={modalTitle}
        onSubmit={handleFormSubmit}
        submitBtnText={submitBtnText}
      >
        <FormProductEdit ref={formRef} handleClose={handleClose}/>
      </ModalV2>

      <Snackbars
        place="tr"
        color={color}
        message={message}
        open={isOpenSnack}
        closeNotification={clearSnackbar}
        close
      /> 
    </React.Fragment>
  )
}
